webpackJsonp([98284113703749],{

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "In deze rijtjes zijn alleen de vormen van het praesens indicativus volledig uitgeschreven. De andere vormen zijn namelijk dusdanig regelmatig, dat de stam leren daarvoor voldoende is."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "velle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "nolle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "malle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ferre"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ire"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "niet willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "liever willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "(ver)dragen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "gaan"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 6 },
	              "prs"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "volo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fers"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fert"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "it"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "volumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ferimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "imus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fertis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "itis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "volunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "nolunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "malunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "ferunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "eunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "ipf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "male"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fere"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013ba\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 3 },
	              "fut"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013o"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013i\u2013s"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013i"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pqp"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013era\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "fex"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013er\u2013o"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "In deze rijtjes zijn alleen de vormen van het praesens indicativus volledig uitgeschreven. De andere vormen zijn namelijk dusdanig regelmatig, dat de stam leren daarvoor voldoende is."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 5 },
	              "indicativus actief"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "velle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "nolle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "malle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ferre"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ire"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "niet willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "liever willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "(ver)dragen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "gaan"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 6 },
	              "prs"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "volo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fers"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fert"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "it"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "volumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ferimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "imus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fertis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "itis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "volunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "nolunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "malunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "ferunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "eunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "ipf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "male"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fere"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013ba\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 3 },
	              "fut"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013o"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013i\u2013s"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013i"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pqp"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013era\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "fex"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013er\u2013o"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 5 },
	              "conjunctivus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "velle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "nolle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "malle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ferre"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ire"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "niet willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "liever willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "(ver)dragen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "gaan"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "prs"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "veli"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "noli"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mali"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fera"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "ea"
	              ),
	              "\u2013m"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "In deze rijtjes zijn alleen de vormen van het praesens indicativus volledig uitgeschreven. De andere vormen zijn namelijk dusdanig regelmatig, dat de stam leren daarvoor voldoende is."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 5 },
	              "indicativus actief"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "velle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "nolle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "malle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ferre"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ire"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "niet willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "liever willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "(ver)dragen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "gaan"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 6 },
	              "prs"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "volo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malo"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fers"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavult"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fert"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "it"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "volumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "nolumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "malumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ferimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "imus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "non vultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "mavultis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fertis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "itis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "volunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "nolunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "malunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "ferunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "eunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "ipf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nole"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "male"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fere"
	              ),
	              "\u2013ba\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013ba\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot", rowSpan: 3 },
	              "fut"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013a\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013o"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "vol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nol"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mal"
	              ),
	              "-e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fer"
	              ),
	              "\u2013e\u2013s"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013b\u2013i\u2013s"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "i",
	                null,
	                "enz."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013i"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013i"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pqp"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013era\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013era\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "fex"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013er\u2013o"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013er\u2013o"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 5 },
	              "conjunctivus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "velle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "nolle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "malle"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ferre"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bor-bot" },
	              "ire"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "niet willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "liever willen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "(ver)dragen"
	            ),
	            _react2.default.createElement(
	              "th",
	              { className: "no-bold" },
	              "gaan"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "prs"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "veli"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "noli"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "mali"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "fera"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "ea"
	              ),
	              "\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "ipf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "velle"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolle"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malle"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "ferre"
	              ),
	              "\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "ire"
	              ),
	              "\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pf"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013eri\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013eri\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013eri\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013eri\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013eri\u2013m"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "pqp"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "volu"
	              ),
	              "\u2013isse\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "nolu"
	              ),
	              "\u2013isse\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "malu"
	              ),
	              "\u2013isse\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "tul"
	              ),
	              "\u2013isse\u2013m"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              _react2.default.createElement(
	                "strong",
	                null,
	                "i"
	              ),
	              "\u2013isse\u2013m"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _velleNolleMalle = __webpack_require__(668);
	
	var _velleNolleMalle2 = _interopRequireDefault(_velleNolleMalle);
	
	var _velleNolleMalle3 = __webpack_require__(669);
	
	var _velleNolleMalle4 = _interopRequireDefault(_velleNolleMalle3);
	
	var _velleNolleMalle5 = __webpack_require__(670);
	
	var _velleNolleMalle6 = _interopRequireDefault(_velleNolleMalle5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "32",
	  table: _velleNolleMalle2.default
	}, {
	  les: "43",
	  table: _velleNolleMalle4.default
	}, {
	  les: "44",
	  table: _velleNolleMalle6.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "44",
	    data: data,
	    title: "Velle, nolle, malle, ferre & ire"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-velle-nolle-malle-ferre-ire-js-8435e7e98df5f5337098.js